import { ADMIN_SCHEMA_NAME, isTypeInSchema } from './typeNameSchema'

export const isAdminUserType = (name: string) => isTypeInSchema(name, ADMIN_SCHEMA_NAME, 'Admin Users')

export default isAdminUserType
